import { render } from "./ShopPage.vue?vue&type=template&id=53473fbc&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"

import "./ShopPage.vue?vue&type=style&index=0&id=53473fbc&lang=scss&scoped=true"
import "./ShopPage.vue?vue&type=style&index=1&id=53473fbc&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53473fbc"]])

export default __exports__